<div class="searchConsole" id="searchConsoleDefult2" aria-hidden="true"
  aria-labelledby="searchConsoleDefultLabel2" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content rounded-0 border-0">
      <app-advance-header (valueChange)='getChildValue($event,breadCrumb)'
        [breadcrumb]="breadCrumb"></app-advance-header>
      <div class="modal-body" style="position: relative; display: block;height: 100vh;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-md-5">
            <div class="brand-trust ">
              <div class="carousel-sec">
                <div class="col-xl-11 mx-auto arrow-cta-slide">
                  <div class="bottom-img search-carousel-custom child  text-center" style="width: 100%;">
                    <ngx-slick-carousel #slickHLModal="slick-carousel" class="carousel imagepreview right gallery2"
                      [config]="imageSlider">
                      <div ngxSlickItem class="item" *ngFor="let item of listingData">
                        <div class="boxx">
                          <h1>{{item.l2_display_name}}</h1>
                          <div class="img-box-slide">
                            <img src="{{item?.l1_image_path_l}}" class="img-fluid left-img">
                            <img src="{{item?.l1_image_path_m}}" class="img-fluid middle-img">
                            <img src="{{item?.l1_image_path_r}}" class="img-fluid right-img">
                          </div>
                          <div class="text-center justify-content-center gap-2 mt-4 slider-cta">
                            <button type="button" class="btn btn-primary btn-grad-primary"
                              data-bs-target="#searchConsoleDefult3" 
                              (click)="getLevel2Data(item)">
                              {{'Explore ' + item.l2_display_name}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </ngx-slick-carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div *ngIf="newsearchDataList.data">
    <app-advance-vehicle-list [searchDataListVehicleMap]="newsearchDataList"    [level2DataMap]="newlevel2Data"></app-advance-vehicle-list>
   </div> -->